/**
 * Gets locale from the AEM localeInfo object
 *
 * @return {?string} - Locale from the window.localeInfo object or null if it is unavailable.
 *
 * @example
 * // returns "en_gb"
 * window.localeInfo = { locale: 'en_gb', country: 'gb'}
 * getLocaleFromAEMLocaleInfo()
 *
 * @example
 * // returns null
 * window.localeInfo = undefined
 * getLocaleFromAEMLocaleInfo()
 */
const getLocaleFromAEMLocaleInfo = () => { var _a; return ((_a = window.localeInfo) === null || _a === void 0 ? void 0 : _a.locale) || null; };
export default getLocaleFromAEMLocaleInfo;
//# sourceMappingURL=getLocaleFromAEMLocaleInfo.js.map